import { ApiRest } from './Api';

export const getUsers = async (data) => {
  try {
    const apiRest = new ApiRest();

    let response = await apiRest.post({
      url: '/api/v1/user/get-users-by-corporate',
      body: data,
    });

    let { users } = response;

    users =
      users && users.length > 0
        ? users.map((user) => ({
            unique_id: user.unique_id,
            _id: user._id,
            full_name: `${user.first_name} ${user.last_name}`,
            email: user.email,
            full_phone: user.full_phone,
            corporate_wallet_limit: user.corporate_wallet_limit,
            travel_expenses_corporate_recurrent_limit:
              user.travel_expenses_corporate_recurrent_limit,
            travel_expenses_corporate_wallet_limit:
              user.travel_expenses_corporate_wallet_limit,
            corporate_recurrent_limit: user.corporate_recurrent_limit,
            is_approved: user.is_approved,
            userStatus: user.userStatus,
            token: user.token,
            enabled_verticals: user.enabled_verticals,
            isPrime: user?.isPrime ?? false,
          }))
        : [];

    response = {
      ...response,
      users,
    };

    return response;
  } catch (e) {
    throw e;
  }
};

export const getUser = async (email, filterByCorporate = true) => {
  if (!email) return;
  try {
    const apiRest = new ApiRest();
    return await apiRest.get({
      url: `/api/v1/user/?email=${email}&filterByCorporate=${filterByCorporate}`,
    });
  } catch (e) {
    throw e;
  }
};

export const getUserByPhone = async (phone, code, filterByCorporate = true) => {
  try {
    const apiRest = new ApiRest();
    return await apiRest.get({
      url: `/api/v1/user/?phone=${phone}&country_phone_code=${encodeURIComponent(
        '+',
      )}${code}&filterByCorporate=${filterByCorporate}`,
    });
  } catch (e) {
    throw e;
  }
};

export const sendUserRequest = async (data) => {
  try {
    const apiRest = new ApiRest();
    return await apiRest.post({
      url: '/api/v1/user/send-request',
      body: data,
    });
  } catch (e) {
    throw e;
  }
};

export const RemoveUser = async (data) => {
  try {
    const apiRest = new ApiRest();
    return await apiRest.post({
      url: '/api/v1/user/remove-user-corporate',
      body: data,
    });
  } catch (e) {
    throw e;
  }
};

export const exportUsersExcel = async (data) => {
  try {
    const apiRest = new ApiRest();
    return await apiRest.post({
      url: '/api/v1/user/export-users-by-corporate',
      body: data,
    });
  } catch (e) {
    throw e;
  }
};

export const addLimit = async (data) => {
  try {
    const apiRest = new ApiRest();
    return await apiRest.post({
      url: '/api/v1/user/add-limit-corporate',
      body: data,
    });
  } catch (e) {
    throw e;
  }
};

export const addRecurrentLimit = async (data) => {
  try {
    const apiRest = new ApiRest();
    return await apiRest.post({
      url: '/api/v1/user/add-recurrent-limit-corporate',
      body: data,
    });
  } catch (e) {
    throw e;
  }
};
export const bulkUpdateUsersWithCsv = async (data) => {
  try {
    const apiRest = new ApiRest();
    return await apiRest.post({
      url: '/api/v1/user/import-users-wallet-by-corporate',
      body: data,
    });
  } catch (e) {
    throw e;
  }
};

export const exportAddUsersExcel = async () => {
  try {
    const apiRest = new ApiRest();
    return await apiRest.get({
      url: '/api/v1/user/export-add-users-template',
    });
  } catch (e) {
    throw e;
  }
};

export const updateVertical = async (userId, data) => {
  try {
    const apiRest = new ApiRest();
    return await apiRest.post({
      url: `/api/v1/user/${userId}/enable-vertical`,
      body: data,
    });
  } catch (e) {
    throw e;
  }
};
